import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberDetailsContentOnOffPrice } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentOnOffPrice"
import { ProgramSubscriberDetailsContentOnOffStatus } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentOnOffStatus"
import { ProgramSubscriberDetailsContentPrice } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentPrice"
import { ProgramSubscriberDetailsContentStatus } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsContentStatus"
import { ProgramSubscriberDetailsMenu } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsMenu"
import { ProgramSubscriberDetailsViewTabs } from "@modules/programs/programSubscriber/entities/programSubsciberType"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { Text } from "@/components/ui/baseUi/text"

type ProgramSubscriberDetailsContentProps = {
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity
  setActiveTab: (tab: ProgramSubscriberDetailsViewTabs) => void
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsContent({
  subscriberDetails,
  setActiveTab,
  programId,
  className,
  ...props
}: ProgramSubscriberDetailsContentProps) {
  return (
    <div className={cn("card mb-6 flex w-full flex-col gap-4 p-0 px-4 py-3", className)} {...props}>
      {/* STATUS */}
      {subscriberDetails instanceof ProgramSubscriberEntity && subscriberDetails.onOffProgramProgression ? (
        <ProgramSubscriberDetailsContentOnOffStatus subscriberDetails={subscriberDetails} />
      ) : (
        <ProgramSubscriberDetailsContentStatus subscriberDetails={subscriberDetails} />
      )}

      {/* PRICE */}
      {subscriberDetails instanceof ProgramSubscriberEntity && subscriberDetails.onOffProgramProgression ? (
        <ProgramSubscriberDetailsContentOnOffPrice subscriberDetails={subscriberDetails} />
      ) : (
        <ProgramSubscriberDetailsContentPrice subscriberDetails={subscriberDetails} />
      )}

      {/* INTERNAL NOTE */}
      <div className="flex w-full flex-col gap-2">
        <div className="flex w-full items-baseline gap-2">
          <Text fontStyle="BS" className="text-textDefault-caption">
            {word("program.subscribers.subscriptionDetails.internalNote.title")}
          </Text>
          <div className="flex grow border-t border-borderDefault" />
        </div>
        <Text fontStyle="BM" className="text-textDefault-heading wrap-anywhere">
          {subscriberDetails.internalNote && subscriberDetails.internalNote !== ""
            ? subscriberDetails.internalNote
            : word("program.subscribers.subscriptionDetails.internalNote.none")}
        </Text>
      </div>

      <div className="flex w-full justify-end gap-2">
        <ProgramSubscriberDetailsMenu
          subscriberDetails={subscriberDetails}
          setActiveTab={setActiveTab}
          programId={programId}
        />
      </div>
    </div>
  )
}
